import React from 'react';
import EventOptionGroupsFormContainer from './../../../../Containers/AdminContainer/EventOptionGroups/EventoptionGroupsForm/index';
const EventOptionGroupsFormScreen = () => {
  return <EventOptionGroupsFormContainer />;
};

export default EventOptionGroupsFormScreen;
